import { StreamCompositionKey, getUnitAttributes } from "@/components/FlowSheetEditor/components/Header/Simulation/Workbook/VariableTable/attributes"
import { UnitSelect, UnitStates } from "@/components/FlowSheetEditor/components/UnitSelect/UnitSelect"
import { NodeState, LineRecord, SetOperation } from "@/components/FlowSheetEditor/services/modal"
import { Select } from "antd"
import { useEffect, useMemo, useState } from "react"
import { CompositionSelect } from "../CompositionSelect/CompositionSelect"

export interface UnitVariableVal {
  unitId?: string
  attrCode?: string
}

interface UnitVariableProps {
 units: UnitStates
 value?: UnitVariableVal
 onChange?: (val: UnitVariableVal | undefined) => void
}

export const UnitVariable = (props: UnitVariableProps) => {
  const {units, value, onChange} = props
  const [unitId, setUnitId] = useState<string | undefined>(value?.unitId)
  const {attr: attrStr, index} = parseVarAtt(value?.attrCode)
  const [attr, setAttr] = useState<string | undefined>(attrStr)
  const [component, setComponent] = useState<number | undefined>(index)

  useEffect(() => {
    setUnitId(value?.unitId)
    const {attr: attrStr, index} = parseVarAtt(value?.attrCode)
    setAttr(attrStr)
    setComponent(index)
  }, [value])

  const unitMap = useMemo(() => {
    const unitMap = new Map<string, NodeState | LineRecord | SetOperation>();
    [...units.nodes, ...units.lines, ...units.operations].forEach(item => {
      unitMap.set(item.id, item)
    })

    return unitMap
  }, [units])

  const getAttrsOptions = (unitId: string | undefined) => {
    if (!unitId) return []
    const unit = unitMap.get(unitId);
    if (!unit) {
      return []
    }
    return getUnitAttributes(unit)
  }

  const valuesChanged = (unitId: string | undefined, attr: string | undefined, compIndex: number | undefined ) => {
    let trueAttr = attr
    if (attr === StreamCompositionKey) {
      if (compIndex !== undefined) {
        trueAttr = `:OUT:xi_$1[${compIndex}]`
      } else {
        return
      }
    }
    if (unitId && attr) {
      onChange?.({
        unitId,
        attrCode: trueAttr
      })
    }
  }

  return <div>
    <div>
      <div className="mb-1">Equipment: </div>
      <UnitSelect
        units={units}
        value={unitId}
        onChange={(val) => {
          setUnitId(val)
          setAttr(undefined)
          valuesChanged(val, undefined, undefined)
        }}
        style={{width: '100%'}}
      />
    </div>
    <div className="mt-1">
      <div className="mb-1">Variable: </div>
      <Select
      value={attr}
      options={getAttrsOptions(unitId)}
      onChange={(val) => {
        setAttr(val)
        valuesChanged(unitId, val, undefined)
      }}
      style={{width: '100%'}}
      />
    </div>
    {unitId && attr === StreamCompositionKey && <div className="mt-1">
      <div className="mb-1">Composition: </div>
      <CompositionSelect unitId={unitId} value={component} onChange={(val) => {
        setComponent(val)
        valuesChanged(unitId, attr, val)
      }} />
    </div>}
    
  </div>
}

function parseVarAtt(attr: string | undefined) {
  if (!attr) {
    return {attr: undefined}
  }
  const matchRes = attr.match(/:OUT:xi_\$1\[(\d+)\]/)
  if (matchRes && matchRes[1]) {
    return {
      attr: StreamCompositionKey,
      index: Number(matchRes[1])
    }
  }
  return {attr}
}